module.exports = __webpack_public_path__ + "img/googleblocksearch.d167e321.png";